<template>
  <div class="page-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <router-link to="/" tag="a" class="logo">
        <img src="../assets/logo.png" />
      </router-link>

      <slot></slot>
    </div>

    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center">
        <slot name="right"></slot>
      </div>

      <div class="currentUser ml-2 d-none">
        <div>
          <strong>{{ userStore.user.shortName }}</strong>
        </div>
      </div>

      <div class="currentUser ml-2" @click="logout" v-if="authMode === 'azuread'">
        <div>
          <strong>Logout</strong>
        </div>
      </div>

      <div class="hubStatus" v-if="!boardStore.hubStatus">
        <div class="connected" v-if="boardStore.hubStatus">Connected</div>
        <div class="disconnected" v-else>Disconnected</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { UserModule, UserStore } from '@/store/user';
  import { BoardModule, BoardStore } from '@/store/board';
  import AuthService from '@/services/auth.service';
  import { AUTH_MODE } from '@/config';

  @Component({})
  export default class PageHeader extends Vue {
    private userStore: UserModule = UserStore;
    private boardStore: BoardModule = BoardStore;
    private authService: AuthService = new AuthService();
    private authMode: string = AUTH_MODE;

    logout() {
      this.authService.logout();
    }
  }
</script>

<style scoped lang="scss">
  .page-header {
    padding: 10px;
    color: white;
    font-size: 1.1rem;
    background: #fff;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.12);

    .logo {
      cursor: pointer;

      img {
        height: 50px;
      }
    }

    .hubStatus {
      color: black;
      padding: 5px;
      border-radius: 4px;
      font-size: 0.8rem;
      font-weight: bold;

      div {
        padding: 5px;
        border-radius: 4px;
      }

      .disconnected {
        background: #e74c3c;
        color: white;
      }

      .connected {
        background: #27ae60;
        color: white;
      }
    }

    .currentUser {
      white-space: nowrap;
      font-size: 0.8rem;
      background: #eaeaea;
      color: black;
      border-radius: 4px;
      padding: 5px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>
